import React from "react";
import classes from './text.module.css';

const Textlistitem = (props) => {
    return(
        <>
            <p>
                <span>{props.item.id}</span>
                <div className={classes.spanBlock}>
                    {props.item.title}
                    <strong>{props.item.body}</strong>
                </div>
            </p>
        </>
       
    )
}

export default Textlistitem;